import { styled } from "styled-components";

export const LoginInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 24px;
`;
